import { render } from "./Step2Body.vue?vue&type=template&id=92f310c2&scoped=true"
import script from "./Step2Body.vue?vue&type=script&lang=js"
export * from "./Step2Body.vue?vue&type=script&lang=js"

import "./Step2Body.vue?vue&type=style&index=0&id=92f310c2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-92f310c2"]])

export default __exports__